module.exports = __webpack_public_path__ + "img/admin_adv_21.a5e9b35b.png";